import { Box, Typography, styled } from '@mui/material'
import { TypographyProps } from '@mui/system'
import { PropsWithChildren } from 'react'

export const Main = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  flexGrow: 1,
  gap: theme.spacing(2),
  padding: '16px 0 0',
}))

export const SubTitle = (props: PropsWithChildren<TypographyProps>) => (
  <Typography
    {...props}
    sx={{
      fontWeight: 600,
      fontSize: '10px',
      textTransform: 'uppercase',
      color: 'content.secondary',
    }}
  >
    {props.children}
  </Typography>
)
